import { v4 as uuidv4 } from "uuid";
import { ScriptedVariable } from "../../common/interfaces/flow/variable/ScriptedVariable";
import { WebRequestAction } from "../interfaces/flow/action/WebRequestAction";

export const template = `
/*
 * Available variables:
 * - response: The response from the previous action.
 * - jsonResponse: The response from the previous action parsed as JSON.
 * - scope: Input data for the action (also accessible via aliases: context and jsonContext).
 *   - scope.payload: The payload received by this script action (either from the previous action or the trigger).
 *   - scope._flow: Flow-level variables shared across all actions.
 * - path(scope, '$.objectName'): A utility to extract a value from an object using a JSONPath expression.
 * - getIssue(): Returns the issue as JSON if it exists, otherwise returns null.
 */
return scope?._flow?.name; // Example: Returns the name of the current flow, if available.
`;


export const newScript = (name: string, code?: string): ScriptedVariable => {
  return { name: name, script: code ? code : template, uuid: uuidv4() };
};

export const addNewScript = (action: WebRequestAction, name?: string, code?: string) => {
  const varName = name ? name : `MyVar_${action?.scriptedVariables?.length}`
  action.scriptedVariables?.push(newScript(`${varName}`, code));
  if (!action.scriptedVariables) {
    action.scriptedVariables = [newScript(varName, code)];
  }
};

export const addScripts = (action: WebRequestAction, scripts: { name: string; code: string }[]) => {
  scripts.forEach((script) => {
    addNewScript(action, script.name, script.code);
  });
};

export const scriptedActionTemplate = `
/*
 * Available variables:
 * - scope: The current scope containing the data accessible to this action.
 *   - scope.payload: The payload received by this script action (either from the previous action or the trigger).
 *   - scope._flow: Flow-level variables shared across all actions.
 * - path(scope, '$.jsonPath'): A utility to extract a value from an object using a JSONPath expression.
 */
return {
  flowName: scope?._flow?.name // The name of the current flow, if available.
};
`;